import {
    Box,
    Container,
    Typography, useMediaQuery, useTheme
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import React from 'react';
import "react-device-frameset/styles/marvel-devices.min.css";
import "../../../App.css";
import iphone_mockup from "../../../assets/Iphone_mockup_v4.png";
import GetStarted from "../../components/GetStartedComponent";
import { theme } from "../../../theme";
import { AppBarPadding, BottomPadding } from "../../../utils/helperUtils";

function VendorHomeView() {

    const themeX = useTheme();

    const isMobile = useMediaQuery(themeX.breakpoints.down("md"))


    return (
        <Box sx={{
            minHeight: '98vh',
            bgcolor: theme.colors.primaryLight
        }}>
            <Container maxWidth="xl" >
                <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    justifyContent="center"
                >
                    <Grid

                        size={{ xs: 12, md: 6 }}
                    >
                        <>
                            <Typography
                                variant={isMobile ? "h4" : "h3"}
                                mt={isMobile ? 6 : 3}
                                fontWeight={700}
                                color="white"
                                textAlign={'center'}
                            >
                                Be your neighborhood's favorite spot
                            </Typography>
                            <Typography
                                variant={"h6"}
                                mt={3}
                                color="white"
                                textAlign={'justify'}
                            >
                                Live location sharing makes it easy for customers to find you. Post photos, collect reviews, and keep them coming back for more — all from your Sidewalk link. Create your storefront in the Sidewalk for Vendors app today.
                            </Typography>
                        </>
                        <br />
                        <GetStarted />
                    </Grid>
                    <Grid
                        size={{ xs: 12, md: 6 }}
                        container
                        justifyContent="center"
                        alignItems="center"
                        pt={{ md: 10 }}
                    >
                        <img
                            alt="iphone_mockup"
                            src={iphone_mockup}
                            className="iphone_mockup"
                            style={{ width: "100%", height: "auto", maxWidth: "370px" }}
                        />
                    </Grid>
                </Grid>
            </Container>
            <BottomPadding />
        </Box>
    )
}

export default VendorHomeView